(function ($) {$(function(){
    const $modal = $('#resume-modal');
    const modalCloseBtn = $('#resume-modal-close');
    const modalOpenBtn = $('#resume-modal-open');

    const $thanksModal = $('#thanks-modal');
    const thanksModalCloseBtn = $('#thanks-modal-close');

    const inputList = $modal.find('.form-group input');
    
    if (inputList.length) {
        inputList.each(function () {
            const $el = $(this);
            const $parentGroup = $el.parents('.form-group');
            if (!$parentGroup.hasClass('no-label-animation')) {
                const label = $el.parents('.form-group').find('label');
                $el.on('focus', function () { activateLabel(label); })
                $el.on('blur', function () { 
                    if ($el.val() == '') {
                        deactivateLabel(label); 
                    }
                })
            }
        });
    }

    if ($modal.length) {
        $modal.find('input[type="file"]').on('change', function(){
            const $this = $(this);
            const file = ($this.val()).split("\\");
            const fileName = file[file.length - 1];
            const group = $this.parents('.cv-group');
            group.find('.file-name').html(fileName)
            group.find('.remove-file').addClass('active')
            // $('.file-name').html(fileName);
        });
        $modal.find('.remove-file').on('click', function(){
            const $this = $(this);
            const group = $this.parents('.cv-group');
            const file = group.find('input[type="file"]')
            file.val('');
            group.find('.file-name').html('Attach PDF')
            $this.removeClass('active');
            // $('.file-name').html(fileName);
        });
    }
    const activateLabel = function ($label) {
        $label.addClass('active');
    }
    const deactivateLabel = function ($label) {
        $label.removeClass('active');
    }
    modalCloseBtn.on('click', function (e) {
        $modal.removeClass('active');
    });
    thanksModalCloseBtn.on('click', function (e) {
        $thanksModal.removeClass('active');
    });
    modalOpenBtn.on('click', function (e) {
        e.preventDefault();
        const $this = $(this);
        const position = $this.data('position');
        const location = $this.data('location');
        $('#field-position').val(position);
        $('#landing-job-title').html(position);
        $('#landing-job-title').html(position);
        $('#landing-job-location').html(location);
        $modal.addClass('active');
    });


    $(document).on('wpcf7mailsent', function(e) {
        $modal.removeClass('active');
        $thanksModal.addClass('active');
        $modal.find('.file-name').html('Attach PDF')
        $modal.find('.remove-file').removeClass('active');
    })

    $(document).on('wpcf7submit', function(e) {
        const button = $('.wpcf7-submit[disabled]');
        button.prop('disabled', false);
        button.val('SUBMIT');
    });
    $('form.wpcf7-form').on('submit',function() {
        const $this = $(this);
        const button = $this.find('input[type=submit]');
        button.prop("disabled", true);
        button.val("Sending...");
    });
});}(_jQ3));

